import { Select, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
//import { useSelector } from "react-redux";
import trans from "../../../utils";

import { popupcontext } from "../../../context/Popupscontext";

import {
	useAssignRoleMutation,
	useGetRolesUsersQuery,
	useRemoveRoleMutation,
} from "../../../Redux/service/Roles&Permissions/RolesPermissions";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useGetAllUsersQuery } from "../../../Redux/service/Users/Users";

export default function AssignRolePopup({ label, styling }) {
	const inf = useSelector((state) => state.users.user);
	const { isAssigning, setIsAssigning, activeRole } = useContext(popupcontext);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AllUsers, refetch: AllUsersReftech } = useGetAllUsersQuery(
		{
			page: 1,
			limit: 10000,
		},
		{ refetchOnMountOrArgChange: true },
	);
	let { data: UserunderUsers, refetch: UserunderUsersRefetch } =
		useGetRolesUsersQuery(
			{ id: activeRole?.id, limit: 10000, page: 1 },
			{ skip: !activeRole?.id, refetchOnMountOrArgChange: true },
		);
	const [assignRole] = useAssignRoleMutation();
	const [unAssignRole] = useRemoveRoleMutation();
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	const handleAssign = async (val) => {
		try {
			await assignRole({
				userId: val, // the selected user
				roleId: activeRole?.id, // the active role
			}).unwrap();
			toast.success(trans("Role assigned to user successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar",
			});
		} catch (error) {
			setSelectedUsers((prev) => prev.filter((v) => v !== val));
			toast.error(`${error?.data?.message}`, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const handleUnAssign = async (val) => {
		try {
			await unAssignRole({ id: val }).unwrap();
			toast.success(trans("Role unassigned from user successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar",
			});
		} catch (error) {
			toast.error(`${error?.data?.message}`, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	console.log("AllUsers", AllUsers);
	console.log("UserunderUsers", UserunderUsers);

	useEffect(() => {
		setGroups(
			AllUsers?.data
				?.filter((i) => i.id !== inf.id)
				.map((i) => ({
					value: i.id,
					label: i.name,
				})),
		);
	}, [AllUsers?.data]);

	useEffect(() => {
		if (UserunderUsers?.data?.length > 0) {
			setSelectedUsers(UserunderUsers.data.map((i) => i.userId));
		}
	}, [UserunderUsers?.data]);

	useEffect(() => {
		if (isAssigning) {
			UserunderUsersRefetch();
		}
	}, [isAssigning]);
	useEffect(() => {
		if (!isAssigning) setSelectedUsers([]);
	}, [isAssigning]);
	return (
		<Popup show={isAssigning} size="lg" style={"popup-bodyscroll"}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={activeRole?.name} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => {
						setIsAssigning(false);
					}}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				<div className={styling}>
					<div className="mult-input-label">{trans("Users")}</div>
					<Space
						style={{
							width: "100%",
							borderColor: "red",
						}}
						direction="vertical"
					>
						<Select
							mode="multiple"
							style={{
								width: "100%",
								marginTop: "8px",
								borderColor: "red",
							}}
							maxTagCount={"responsive"}
							placeholder={trans("Please select")}
							onSelect={(value) => {
								setSelectedUsers((prev) => [...prev, value]);
								handleAssign(value);
							}}
							onDeselect={(value) => {
								setSelectedUsers((prev) => prev.filter((v) => v !== value));
								handleUnAssign(value);
							}}
							value={AllUsers?.data?.length > 0 ? selectedUsers : undefined}
							options={groups}
							open={isOpen}
							onDropdownVisibleChange={handleDropdownVisibleChange}
							filterOption={(input, option) =>
								option.label.toLowerCase().includes(input.toLowerCase())
							}
						/>
					</Space>
				</div>
			</Modal.Body>
		</Popup>
	);
}
